// extracted by mini-css-extract-plugin
export default {"nav":"GroupMobileNav_nav__XQQmW","tab":"GroupMobileNav_tab__hCXNU"};